//product tabs
  $(document).ready(function() {
    $('ul.tabs_pro').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active_tabs');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active_tabs');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active_tabs');
        content.show();
        return false;
      });
    });
  });
